import styled from "styled-components";

export const StyledLayout = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  .header-wrap {
    width: 100%;
  }

  .main-wrap {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    height: calc(100% - 5.6rem);
    /* transition: all 0.2s ease; */
    background-color: var(--bg-gray-1);
    z-index: 110;

    .main-contents {
      position: relative;
      transition: all 0.2s ease;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
`;
